import AsyncStorage from "@react-native-async-storage/async-storage"
import React from "react"
import { Image, ImageResizeMode, ImageStyle, Platform, StyleProp } from "react-native"
import { getDoorhubFileUrl } from "../utils/itemImage"

interface Props {
	fileId?: string | null
	style?: StyleProp<ImageStyle>
	resizeMode?: ImageResizeMode
}

const DOORHUB_TOKEN_ID = "doorhub_token"

export const DoorhubFileImage = ({ fileId, style, resizeMode }: Props) => {
	const url = getDoorhubFileUrl(fileId)
	const [token, setToken] = React.useState<string | null>(null)
	const [webObjectUrl, setWebObjectUrl] = React.useState<string | null>(null)

	React.useEffect(() => {
		let cancelled = false

		if (!url) {
			setToken(null)
			return
		}

		AsyncStorage.getItem(DOORHUB_TOKEN_ID).then((storedToken) => {
			if (cancelled) {
				return
			}

			setToken(storedToken)
		})

		return () => {
			cancelled = true
		}
	}, [url])

	React.useEffect(() => {
		if (Platform.OS !== "web") {
			return
		}

		if (!url || !token) {
			return
		}

		let active = true

		fetch(url, {
			headers: {
				authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`Failed to load file ${response.status}`)
				}
				return response.blob()
			})
			.then((blob) => {
				if (!active) {
					return
				}

				const nextUrl = URL.createObjectURL(blob)
				setWebObjectUrl((previous) => {
					if (previous) {
						URL.revokeObjectURL(previous)
					}
					return nextUrl
				})
			})
			.catch(() => {
				if (!active) {
					return
				}
				setWebObjectUrl(null)
			})

		return () => {
			active = false
		}
	}, [token, url])

	React.useEffect(() => {
		return () => {
			if (webObjectUrl) {
				URL.revokeObjectURL(webObjectUrl)
			}
		}
	}, [webObjectUrl])

	if (!url) {
		return null
	}

	if (Platform.OS === "web") {
		if (!webObjectUrl) {
			return null
		}

		return (
			<Image
				style={style}
				resizeMode={resizeMode}
				source={{ uri: webObjectUrl }}
			/>
		)
	}

	const headers = token
		? {
			authorization: `Bearer ${token}`,
		}
		: undefined

	return (
		<Image
			style={style}
			resizeMode={resizeMode}
			source={headers ? { uri: url, headers } : { uri: url }}
		/>
	)
}
